<div class="modal-overlay" *ngIf="media" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>{{ isVideo ? 'Video' : 'Image' }} Preview</h3>
      <button class="close-btn" (click)="onClose()" title="Close">×</button>
    </div>

    <div class="modal-body">
      <!-- Video Preview Component -->

      <!-- Image Preview -->
      <div *ngIf="isImage" class="image-preview">
        <img [src]="image?.url" [alt]="image?.s3Id" />
      </div>

      <!-- Timeline Container (only for videos) -->
      <div *ngIf="isVideo" class="timeline-container">
        <nw-video-preview
          *ngIf="isVideo"
          #videoPreview
          [videoShape]="videoShape"
          (timeRangeChange)="onTimeRangeChange($event)"
        ></nw-video-preview>
      </div>
    </div>
    <div
      style="
        height: 33px;
        border-top: 2px solid #000;
        display: flex;
        align-items: center;
        justify-content: space-around;
      "
      (click)="onDone()"
    >
      <nw-icon type="check" [size]="18"></nw-icon>
    </div>
  </div>
</div>
